var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.141,
    height: 247.141,
    viewBox: "0 0 247.141 247.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_76_22",
    "data-name": "Component 76 \\u2013 22",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g443",
    transform: "translate(68.82 84.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "M-164.56,0l-67.411,67.411-32.091-32.09",
    transform: "translate(264.062)",
    fill: "none",
    stroke: "#00ab79",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path457",
    d: "M-392.191-196.1a118.57,118.57,0,0,1-118.57,118.57A118.57,118.57,0,0,1-629.332-196.1a118.57,118.57,0,0,1,118.57-118.57A118.57,118.57,0,0,1-392.191-196.1Z",
    transform: "translate(629.332 314.666)",
    fill: "none",
    stroke: "#00ab79",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.242a39bd6049070451da9cd781deec88.svg";
export { ForwardRef as ReactComponent };